import script from "./ZlButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ZlButton.vue?vue&type=script&setup=true&lang=js"

import "./ZlButton.vue?vue&type=style&index=0&id=1b3f8974&lang=css"

const __exports__ = script;

export default __exports__